module.exports = __webpack_public_path__ + "static/img/rg_pic.267bd30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rg_pic.jpg
// module id = aSl1
// module chunks = 5